module.exports = {
  controller: 'GoldmoneyBarsController',
  controllerAs: 'redeemCtrl',
  template: '<ui-view></ui-view>',
};

angular.module('app.holding.dashboard.physical')
  .controller(module.exports.controller, GoldmoneyBarsController);

function GoldmoneyBarsController() {
  'ngInject';
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/physical/states/delivery/delivery.js